import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { StarField } from "@/components/StarField";

function Loading() {
  return (
    <div className="min-h-screen bg-[#080B1A] flex items-center justify-center relative">
      <StarField count={40} />
      <div className="relative z-10 text-amber-200/80 font-serif text-xl animate-pulse">
        Aligning the stars…
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
}
